module.exports = __webpack_public_path__ + "img/sdyu_logo.17630c86.png";